import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_COMPETITOR_PROPERTY: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_COMPSET",
  type: ConfigurationPageType.TABLE,
  path: "competitors",
  label: "COMPETITOR_PROPERTY",
  model: {
    entityName: "property_datafeed",
    label: "COMPETITOR_PROPERTY",
    path: "/api/competitors",
    bulkPath: "/api/competitors/bulk-updates",
    name: "Competitor property",
    attributes: [
      {
        className: "greyText",
        key: "property_code",
        order: 1,
        label: "PROPERTY_DATAFEED",
        visible: true,
      },
      {
        className: "greyText",
        key: "competitor_code",
        order: 2,
        label: "COMPETITOR_DATAFEED",
        visible: true,
      },
      {
        key: "short_name",
        order: 3,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 4,
        label: "NAME",
        visible: true,
      },
      {
        key: "stars",
        order: 5,
        label: "STARS",
        visible: true,
      },
      {
        key: "property.hebergement_nom_court",
        order: 6,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "kpi_compset.label",
        order: 7,
        label: "KPI_COMPSET",
        visible: true,
      },
      {
        key: "is_main_competitor",
        order: 8,
        label: "MAIN_COMPETITOR",
        visible: true,
        type: FormatType.BOOLEAN,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "is_shown",
        order: 9,
        label: "SHOWN",
        visible: true,
        type: FormatType.BOOLEAN,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      {
        key: "is_active",
        order: 10,
        label: "ACTIVE",
        visible: true,
        type: FormatType.BOOLEAN,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/competitors/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/competitors/export" },
  },
  options: {
    formFields: [
      {
        key: "property_code",
        type: ConfigurationFormType.Input,
        label: "PROPERTY_DATAFEED",
      },
      {
        key: "competitor_code",
        type: ConfigurationFormType.Input,
        label: "COMPETITOR_DATAFEED",
      },
      {
        key: "short_name",
        type: ConfigurationFormType.Input,
        label: "SHORT_NAME",
      },
      {
        key: "name",
        type: ConfigurationFormType.Input,
        label: "NAME",
      },
      {
        key: "stars",
        type: ConfigurationFormType.Input,
        label: "STARS",
      },
      {
        key: "property",
        type: ConfigurationFormType.Select,
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
      },
      {
        key: "kpi_compset",
        type: ConfigurationFormType.Select,
        label: "KPI_COMPSET",
        labelKey: "label",
        api: "/api/kpis/",
        apiParams: {
          page_size: 100,
          ordering: "id",
          code__contains: "prix_compset_",
        },
      },
      {
        key: "is_main_competitor",
        type: ConfigurationFormType.Check,
        label: "MAIN_COMPETITOR",
      },
      {
        key: "is_shown",
        type: ConfigurationFormType.Check,
        label: "SHOWN",
      },
      {
        key: "is_active",
        type: ConfigurationFormType.Check,
        label: "ACTIVE",
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "property_code",
        flex: "50%",
        required: true,
      },
      {
        key: "competitor_code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "stars",
        flex: "50%",
        required: false,
      },
      {
        key: "property",
        flex: "100%",
        required: false,
      },
      {
        key: "kpi_compset",
        flex: "100%",
      },
      {
        key: "is_main_competitor",
        flex: "50%",
      },
      {
        key: "is_shown",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "property_code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "competitor_code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
      },
      {
        key: "name",
        flex: "50%",
      },
      {
        key: "stars",
        flex: "50%",
      },
      {
        key: "property",
        flex: "100%",
      },
      {
        key: "kpi_compset",
        flex: "100%",
      },
      {
        key: "is_main_competitor",
        flex: "50%",
      },
      {
        key: "is_shown",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "property",
        flex: "100%",
      },
      {
        key: "kpi_compset",
        flex: "100%",
      },
      {
        key: "is_shown",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
  },
};

export const SURQUAL_COMPETITOR_PROPERTY_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "COMPETITOR_SURQUAL",
  flagDisabled: "is_new_competitor_management",
  pageLabel: "COMPETITOR_TITLE_SURQUAL",
  menuLabel: "COMPETITOR",
  name: "Competitor",
  path: "competitors",
  tabs: [SURQUAL_COMPETITOR_PROPERTY],
};
